<!-- 搜索结果 - 视频结果 -->


<template>
	<div class="video-wrap clearFloat">
		<!-- single video box -->
        <div class="singleVideoBox" :data-id="video.videoID" v-for="(video,index) in results.data">
        	<a @click="openPage(video.webUrl)" href="javascript:;" class="video-link"  @mouseenter="startPlayVideo" @mouseleave="stopPlayVideo">
		    	  <img v-lazy="video.imgObj" class="videoConBox"/>
            <div class="play-btn" style="border-radius: 50%;">
              <img src="../../assets/search/triangle.png" />
            </div>
		      </a>
		    <a @click="openPage(video.webUrl)" href="javascript:;" @mouseenter="startPlayVideo" @mouseleave="stopPlayVideo">
			    <div class="videoInfoBox">
				    <span class="videoText">{{video.source}}</span>
				    <span class="videoText">{{video.time}}</span>
			    </div>
		    </a>
		    <div class="videoInfoTitle">
		    	<a @click="openPage(video.webUrl)" :title="video.webTitle" href="javascript:;" style="width:80%" class="text-title">
		    		<p class="videoSubtit" v-html="video.webTitleFormat"></p>
		    	</a>
          <div class="videoIsSave" v-if="!video.hasAction">{{video.statusDesc}}</div>
          <div class="videoNotSave" v-if="video.hasAction" @click="saveEvidence(index)">存证</div>
		    </div>
	    </div>
	</div>
</template>

<script>

import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

//缩略图懒加载
// Vue.use(VueLazyload,{
// 	error: require('../../assets/imgRes/error.png'),
// 	loading: require('../../assets/imgRes/loading.gif'),
// 	try:1, //默认3
// 	listenEvents: ['scroll']
// })
Vue.use(VueLazyload,{})

export default {
	props: ['results'],
	name: 'videoResults',
  mounted () {
//    this.init();
  },
	data () {
		return {
			videoItems: []
		}
	},
	methods: {
//    init(){
//      let path = this.$router.currentRoute.path;
//      let keyword = typeof this.$router.currentRoute.query.keyword == 'undefined' ? '' : decodeURIComponent(this.$router.currentRoute.query.keyword);
//      this.$emit('changeChild', path.substring(path.lastIndexOf('/')+1), keyword);
//    },
		getID (videoID) {
		},
    saveEvidence(id){
      this.$emit('savingEvidence', id);
    },
    openPage(url){
      window.open(url);
    },
    stopPlayVideo(e) {
      $(e.target).parent().find('.play-btn').hide();
    },
    startPlayVideo(e) {
      $(e.target).parent().find('.play-btn').show();
    }
	},
  watch: {
    '$route' (to, from) {
      //刷新参数放到这里里面去触发就可以刷新相同界面了
//      this.init();
    }
  }
}
</script>

<style scoped>
	.text-title{
		word-break:break-all;
		display:-webkit-box;
		-webkit-line-clamp:2;
		-webkit-box-orient:vertical;
		overflow:hidden;
	}
	/* reset style */
	p{
		margin:0;
		padding:0;
	}
	a{
		text-decoration: none;
		color: #000;
	}
    img{
      border:0;
    }
	/* clear float style */
    .clearFloat:after{
    	content: '.';
    	height: 0;
    	overflow: hidden;
    	clear: both;
    	visibility: hidden;
    	display: block;
    	cursor: pointer;
    }
	/* video results style */
	.singleVideoBox{
		height: 179px;
		width: 196px;
		position: relative;
		float: left;
		margin-right: 11px;
	}
	.singleVideoBox:nth-child(5n){
		margin-right: 0;
	}
	.videoConBox{
		width: 100%;
		height: 109px;
		display: block;
		user-select: none;
	}
	.videoInfoBox{
		height:30px;
		color:#fff;
		width:100%;
		position:absolute;
		left:0;
		top:79px;
		padding:4px 3px 6px 7px;
		box-sizing:border-box;
		display: flex;
		justify-content: space-between;
		cursor: pointer;
	}
	.videoInfoBox .videoText{
		font-size:12px;
		font-weight: 600;
		text-align:left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		user-select: none;
	}
	.videoInfoTitle{
		display: flex;
		justify-content: space-between;
		font-size: 12px;
		padding-top: 18px;
    position: relative;
    height: 32px;
    overflow: hidden;
	}
	.videoInfoTitle .videoSubtit{
		color: #000;
		cursor: pointer;
    width: 157px;
	}
	.videoInfoTitle .videoIsSave{
    position: absolute;
		color:#565656;
    cursor: not-allowed;
    right: 0;
    top:18px;
	}
	.videoInfoTitle .videoNotSave{
    position: absolute;
		color:#d0021b;
    cursor: pointer;
    right: 0;
    top:18px;
	}
	.videoInfoTitle .saveBtn{
		font-size:12px;
	}
  .video-link{
    display: block;
    width: 196px;
    height:109px;
    position: relative;

  }
  .play-btn{
    position: absolute;
    width:48px;
    height:48px;
    left:0;
    top:0;
    bottom:0;
    right:0;
    margin: auto;
    display: none;
    background: rgba(0, 0, 0, 0.4);
  }
  .play-btn img{
    display: block;
    margin:12px 0 0 19px;
  }
</style>



// WEBPACK FOOTER //
// VideoResults.vue?51e51e13